import { render, staticRenderFns } from "./senha.vue?vue&type=template&id=052e1164&scoped=true"
import script from "./senha.vue?vue&type=script&lang=js"
export * from "./senha.vue?vue&type=script&lang=js"
import style0 from "./senha.vue?vue&type=style&index=0&id=052e1164&prod&lang=css"
import style1 from "./senha.vue?vue&type=style&index=1&id=052e1164&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "052e1164",
  null
  
)

export default component.exports